export default __webpack_public_path__ + "static/media/Bmw2.e6fa4f4f.jpg";